import React from 'react';
//import { Link } from 'react-router-dom';
import './silwaneactivities.css';
import { Link } from 'react-router-dom';


const Silwaneactivities = () => {

    const handleClick = () => {
        window.scrollTo(0, 0); // Scroll to the top
    };

  
  return (
    <>
    <div className="silwameactivitiescont">

        <div className="activitiesimgcont">
            <img src="https://optimize.sirv.com/silwane/IMG_7048.JPG" alt="silwanefalls" />
        </div>

        <div className='silwaneactivitiesintro'>
            <div className='silwaneactivitiesparasecti'>
                <h2>Activities</h2>
                <p>Silwane Nature Reserve offers more than just stunning landscapes and wildlife; we provide an exciting array of adventure and leisure activities suitable for all ages! Whether you're seeking high-octane thrills or family fun, there's something here for everyone to enjoy the natural beauty of the reserve in a unique way.</p>
                <p>Get ready to explore the reserve and create lasting memories with our selection of activities, including Quad Bike Riding, relaxing Boat Rides, challenging Archery sessions, and peaceful Horseback Riding. For our younger visitors, we offer dedicated fun with a Jumping Castle and Trampoline.</p>
            </div>
            <Link 
                to="/experiences" 
                onClick={handleClick}
                //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                //state = {{
                //    data: { majorevents: "waterfalls", abt: "" } 
                //}}
                style={{ textDecoration: 'none', color: 'black' }}
            >
            <div className="silwaneactivitiesbutton">
                <p>Explore More</p>
            </div>
            </Link>
        </div>
      
    </div>

    
   
    </>
  );
};
  
export default Silwaneactivities;
  